import React from 'react'
import Find from '../share/components/Find/Find'
import CarouselSevices, {servicesTravel} from '../share/components/CarouselServices/CarouselSevices'
import BannerRecovery from './BannerRecoveryHouse/BannerRecoveryHouse'
import UseRecovery from '../../viewModels/RecoveryHouse/UseRecovery'
import AllCardsRecovery from './AllCardRecovery/AllCardsRecovery'
import Paginado from './Paginado/Paginado'
import ButtonsFilters from './ButtonsFilters/ButtonsFilters'

const RecoveryHouse = () => {

const {
    dataRecovery,
    urlImage,
    currentPage,
    nextHandler,
    prevHandler,
    mostrarNext,
    services,
    loading,
    personalizeFind,
    detailRecovery
  
} = UseRecovery()

  return (
    <div>
        <Find/>
        <CarouselSevices current={servicesTravel[12].title}/>
        <BannerRecovery/> 
        <ButtonsFilters filterNamePharmacy={personalizeFind}/>
        <AllCardsRecovery dataRecovery={dataRecovery} loading={loading} urlImage={urlImage} detailRecovery={detailRecovery}/>
        <Paginado currentPage={currentPage} data={services} mostrarNext={mostrarNext} nextHandler={nextHandler} prevHandler={prevHandler}/>
    </div>
  )
}

export default RecoveryHouse